import classNames from 'classnames';
import React from 'react';
import styles from "./card-secondary-content.module.css";
/**
 * ### CardSecondaryContent component
 *
 * @remarks
 *
 * Renders a common component for secondary content below a card's primary content.
 *
 * @internal
 */

export const CardSecondaryContent = _ref => {
  let {
    children,
    className,
    showBorder = true
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.secondary, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['secondary-content'], {
      [styles['with-border']]: showBorder
    })
  }, children));
};
//# sourceMappingURL=card-secondary-content.react-component.js.map